import React, { Component } from 'react';

import api from '../../api/';
import auth from '../../auth/';

import ParadigmaAsyncSeeker from '../../components/ParadigmaAsyncSeeker_v2/';
import ParadigmaTable from "../../components/ParadigmaTable/"
import functions from '../../functions/';
import 'react-datetime/css/react-datetime.css';
import ProductividadExportModal from './ProductividadExportModal';
import dateFunctions from '../functions/dateFunctions';
import DateFilter from '../../components/ParadigmaTable/DateFilter';

class Productividad extends Component {
    constructor() {
        super();
        this.state = {
            startDate: null,
            filter: [],
            usuarios: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "personal_id",
                    id: "personal_id",
                    accessor: "personal_id",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha_imputacion",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDate(d.fecha_imputacion),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "name",
                    accessor: d => d.name,
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa",
                    width: 200,
                    accessor: d => d.empresa,
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Importe ($)",
                    id: "importe",
                    width: 150,
                    accessor: d => functions.formatCurrency(d.importe),
                    show: true,
                    filterable: false,
                    className: "text-right",
                },
            ]
        };
    }

    onChangeUsuario(data) {
        let filter = [];
        if (data) {
            filter.push({ 'id': 'personal__id', 'value': [data].map(x => x.id).join(',') });
        }
        this.setState({ usuarios: data ? data.id : null, filter: filter });
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        detail: true,
                        permission: 'solicitudes_view',
                        component: (props) => <ProductividadExportModal {...props} ejecutor={this.state.usuarios} />,
                    },
                ]}
                outerFilter={this.state.filter}
                customSearchElement={
                    (auth.hasPermission('administrador') || auth.hasPermission('soberana')
                        ? <div className="mimicTableHeader ui-form">
                            <section className="ui-section-block">
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <label>Ejecutor</label>
                                        <ParadigmaAsyncSeeker
                                            fieldName={""}
                                            multiselect={true}
                                            displayField={"fullname"}
                                            url={api.usuarios.personal.select}
                                            onChange={(data) => this.onChangeUsuario(data && data.length ? data[0] : null)}
                                            value={this.state.usuarios}
                                        />
                                    </div>
                                </div>
                            </section>
                        </div>
                        : <div></div>
                    )
                }
                apiUrl={api.proyectos.cargadatos.productividad.list}
                columns={this.state.columns}
                title={"Productividad"}
            />
        );
    }
}

export default Productividad;



// WEBPACK FOOTER //
// ./src/views/Consultas/Productividad.js